import React, { Component } from 'react';
import { inject, observer } from 'mobx-react'
import CollectionsSidebar from './CollectionsSidebar';

@inject('myCollectionsStore')
@observer
class MyCollections extends Component {
  render() {
    return <CollectionsSidebar positionMenu={true} store={this.props.myCollectionsStore} showAddButton={true} />
  }
}

export default MyCollections;
